import Vue from 'vue';
import DomainStatus from "../../DomainStatus";
import TLD from "../../TLD";

export default {
    state: {
        /**
         *
         * Example schema:
         * {
         *     1: {
         *         COM: 'AVAILABLE',
         *         IO: 'NOT_AVAILABLE'
         *     }
         * }
         *
         * Here 1 = word id, COM and IO etc = TLD strings, and Available / NOT_AVAILABLE etc = DomainStatuses
         */
        cache: {}

    },
    getters: {
        domainStatus: (state) => (wordId, tld) => {
            if (typeof state.cache[wordId] === "undefined")
                return DomainStatus.CHECKING;

            if (typeof state.cache[wordId][tld] === "undefined")
                return DomainStatus.CHECKING;

            return state.cache[wordId][tld]
        },

        //In case of infinite scroll etc, this method is used to make sure we only request status of words which havent
        //already been requested
        shouldCheckDomainStatus: (state) => (wordId, tld) => {
            if (typeof state.cache[wordId] === "undefined")
                return true;

            if (typeof state.cache[wordId][tld] === "undefined")
                return true;

            return false;
        }
    },

    mutations: {
        setDomainStatus(state, deets) {
            const wordId = deets.id;
            const tld = deets.tld;

            //Using Vue.set to trigger update in view since the keys may not exist in advance, so Vue.set must
            //be used
            if (typeof state.cache[wordId] === "undefined")
                Vue.set(state.cache, wordId, {});

            Vue.set(state.cache[wordId], tld, deets.status);

            if (deets.status === DomainStatus.UNKNOWN)
                window.console.warn("Unknown status:", wordId, tld, deets.status);
        },
    },

    actions: {

        fetchDomainStatus(state, results, x){
            window.console.log("Fetching domain statuses", results, state, x);
            const wordsToCheck = [];

            //alias:
            const tlds = [TLD.COM, TLD.NET, TLD.IO];
            const shouldCheck = state.getters.shouldCheckDomainStatus;

            results.forEach(word => {
                tlds.forEach(tld => {
                    if (shouldCheck(word.id, tld)) {
                        const item = {
                            word_id: word.id,
                            tld: tld
                        };
                        wordsToCheck.push(item);

                        //Commit a checking status so we don't request this domain's status again
                        state.commit("setDomainStatus", {
                            id: word.id,
                            tld: tld,
                            status: DomainStatus.CHECKING
                        })
                    }
                });
            });

            window.console.log("To check: ", wordsToCheck);

            if (wordsToCheck.length <= 0)
                return;

            state.getters.ws.socketPromise.then(socket => {
                socket.checkDomains(wordsToCheck);
            })
        },

    },

}